export function stripTrailingSlash(url) {
    return url === null || url === void 0 ? void 0 : url.replace(/\/$/, "");
}
//# sourceMappingURL=url.js.map